// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// Components
import { DatepickerComponent } from './components/datepicker';
import { EditorComponent } from './components/editor';
// Directives
import { ControlStatusDirective } from './directives/control-status';
import { DateFormatDirective } from './directives/date-format';
import { EmailValidDirective } from './directives/email-valid';
import { HoursFormatDirective } from './directives/hours-format';
import { PasswordGenerateDirective } from './directives/password-generate';
import { PasswordStrengthDirective } from './directives/password-strength';
import { PostCodeFormatDirective } from './directives/post-code-format';
import { ReplacePatternDirective } from './directives/replace-pattern';
import { SameValueValidDirective } from './directives/same-value-valid';
import { SearchInputDirective } from './directives/search-input';
import { SelectPlaceholderDirective } from './directives/select-placeholder';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [
    DatepickerComponent,
    EditorComponent,
    ControlStatusDirective,
    DateFormatDirective,
    EmailValidDirective,
    HoursFormatDirective,
    PasswordGenerateDirective,
    PasswordStrengthDirective,
    PostCodeFormatDirective,
    ReplacePatternDirective,
    SameValueValidDirective,
    SearchInputDirective,
    SelectPlaceholderDirective
  ],
  exports: [
    DatepickerComponent,
    EditorComponent,
    ControlStatusDirective,
    DateFormatDirective,
    EmailValidDirective,
    HoursFormatDirective,
    PasswordGenerateDirective,
    PasswordStrengthDirective,
    PostCodeFormatDirective,
    ReplacePatternDirective,
    SameValueValidDirective,
    SearchInputDirective,
    SelectPlaceholderDirective
  ]
})
export class FormModule {

  constructor() {
  }
}
